import { breakpoints, matchBreakpoint } from "./common/utils";
$(window).resize(() => {
  matchBreakpoint(breakpoints.md, "min");
  matchBreakpoint(breakpoints.lg, "max");
  matchBreakpoint(breakpoints.md, "max");
});
import "./components/language-popup";
import "./components/sticked-navigation";
//import "./components/mobile-main-navigation";
import "./components/desktop-dropdown-navigation";
import "./components/accordion";
import "./components/tabs";
import "./components/slick";
import "./components/match-height";
import "./components/category-filter";
import "./components/category-navigation";
import "./components/products-search";
import "./components/products-nav-mobile";
import "./components/magnific-popup";
import "./components/scroll-to";
//import "./components/google-map";
import "./components/hot-spots";
import "./components/shop-locations-modal";
//import "./components/shops-locations";
import "./components/modal";
import "./components/sticked-where-to-buy";
import "./components/wish-list";
import "./components/products-comparision";
import "./components/trader";
import "./components/content-hub-categories";
import "./components/step-by-step";
//import "./components/disable-store-locator";
import "./components/blog";
import "./modules/cf7";
import "./modules/store-locator";
//import "./components/mobile-search";
import "./components/academy";
import "./components/single-sidebar-modal";
import "./components/sectors-product-mobile";
